<template>
  <main>
    <div class="container-fluid mt-3" style="max-width: 800px">
      <div class="row m-3" v-if="erro">
        <div class="col card my-2 badge-danger text-center p-3 text-uppercase mt-3">
          {{ erro }}
        </div>
      </div>

      <form @submit.prevent="registerUser">

        <div class="row mb-3 g-3 mt-3">
          <div class="col">
            <div class="form-check-inline">
              <input disabled class="form-check-input " type="radio" name="tipo" v-model="register.usuarioTipo"
                value="PF_TITULAR">
              <label class="form-check-label">
                <strong>Pessoa Física</strong>
              </label>
            </div>
            <div class="b-3 form-check-inline">
              <input disabled class="form-check-input " type="radio" name="tipo" v-model="register.usuarioTipo"
                value="PJ_TITULAR">
              <label class="form-check-label">
                <strong>Pessoa Jurídica</strong>
              </label>
            </div>
          </div>
        </div>

        <div class="row mb-3 g-3 mt-3">
          <div class="col">
            <h5><strong> Dados de acesso</strong></h5>
            <div class="a-divider a-divider-break"></div>
          </div>
        </div>
        <div class="row mb-3 g-3">
          <div class="col-sm-6">
            <label for="usuario" class="form-label">Login</label>
            <input disabled class="form-control" type="text" id="usuario" v-model="register.usuario" required />
          </div>

          <div class="col-sm-6">
            <label for="passwordR" class="form-label">Senha</label>
            <input class="form-control" type="password" id="passwordR" placeholder="* * * * *"
              v-model="register.password" required />
            <small>
              <strong>Sua senha deve conter:</strong>
              <ul>
                <li :class="[validarSenhaTamanho() ? 'text-success' : 'text-danger']">Pelo menos 6 caracteres</li>
                <li :class="[validarSenhaLetras() ? 'text-success' : 'text-danger']">Pelo menos uma letra</li>
                <li :class="[validarSenhaNumeros() ? 'text-success' : 'text-danger']">Pelo menos um número</li>
                <li :class="[validarSenhaCaracteresEspeciais() ? 'text-success' : 'text-danger']">Pelo menos um
                  caractere especial</li>
              </ul>
            </small>
          </div>
        </div>
        <div class="row mb-3 g-3 mt-5" v-if="register.usuarioTipo == 'PJ_TITULAR'">
          <div class="col">
            <h5><strong>Dados da Empresa</strong></h5>
            <div class="a-divider a-divider-break"></div>
          </div>
        </div>

        <div v-if="register.usuarioTipo == 'PJ_TITULAR'">
          <div class="row mb-3 g-3">
            <div class="col-sm-6">
              <label for="usuario" class="form-label">CNPJ</label>
              <input disabled class="form-control" type="text" id="usuario" placeholder="000.000.000-00"
                v-model="register.cnpj" v-mask="['###.###.###-##', '##.###.###/####-##']" required />
            </div>
            <div class="col-sm-6">
              <label for="celular" class="form-label">Telefone</label>
              <input class="form-control" type="tel" id="celular" v-model="register.celular"
                v-mask="['(##) ####-####', '(##) #####-####']" placeholder="(00) 00000-0000" required />
            </div>
          </div>
          <div class="row mb-3 g-3">
            <div class="col-sm-6">
              <label for="razaoSocial" class="form-label">Razão social</label>
              <input class="form-control" type="text" id="razaoSocial" v-model="register.razaoSocial" required />
            </div>
            <div class="col-sm-6">
              <label for="nomeFantasia" class="form-label">Nome Fantasia</label>
              <input class="form-control" type="text" id="nomeFantasia" v-model="register.nomeFantasia" required />
            </div>
          </div>


          <div class="row mb-3 g-3">
            <div class="col-sm-6">
              <label for="enderecoCep" class="form-label">Informe o CEP (Opcional)</label>
              <input @keyup.enter="getByCep(true)" @blur="getByCep(true)" class="form-control" type="text"
                id="enderecoCep" placeholder="00000-00" v-model="register.enderecoPJ.cep" v-mask="['#####-###']" />
              <small class="text-muted" v-if="loadingCep">
                <span class="spinner-border spinner-border-sm"></span>
                Buscando seu CEP
                <span class="button-loader grey ml-2"></span>
              </small>
              <small class="text-danger" v-if="cepNaoLocalizado && isConsultaCepPJ">CEP não localizado</small>
            </div>
            <div class="col-sm-6">
              <label for="enderecoUf" class="form-label">UF (Opcional)</label>
              <input disabled class="form-control" type="text" id="enderecoUf" v-model="register.enderecoPJ.estado" />
            </div>
          </div>
          <div class="row mb-3 g-3">
            <div class="col-sm-6">
              <label for="enderecoCidade" class="form-label">Cidade (Opcional)</label>
              <input disabled class="form-control" type="text" id="enderecoCidade"
                v-model="register.enderecoPJ.cidade" />
            </div>
            <div class="col-sm-6">
              <label for="enderecoBairro" class="form-label">Bairro (Opcional)</label>
              <input disabled class="form-control" type="text" id="enderecoBairro"
                v-model="register.enderecoPJ.bairro" />
            </div>
          </div>
          <div class="row mb-3 g-3">
            <div class="col-sm-6">
              <label for="enderecoLogradouro" class="form-label">Endereço (Opcional)</label>
              <input disabled class="form-control" type="text" id="enderecoLogradouro"
                v-model="register.enderecoPJ.endereco" />
            </div>
            <div class="col-sm-6">
              <label for="enderecoNumero" class="form-label">Número (Opcional)</label>
              <input class="form-control" type="text" id="enderecoNumero" v-model="register.enderecoPJ.numero" />
            </div>
          </div>
          <div class="row mb-3 g-3">
            <div class="col-sm-6">
              <label for="enderecoComplemento" class="form-label">Complemento (Opcional)</label>
              <input class="form-control" type="text" id="enderecoComplemento"
                v-model="register.enderecoPJ.complemento" />
            </div>
          </div>
        </div>

        <div class="row mb-3 g-3 mt-5">
          <div class="col">
            <h5 v-if="register.usuarioTipo == 'PJ_TITULAR'"><strong> Dados do responsável</strong></h5>
            <h5 v-if="register.usuarioTipo == 'PF_TITULAR'"><strong> Dados pessoais</strong></h5>
            <div class="a-divider a-divider-break"></div>
          </div>
        </div>

        <div class="row mb-3 g-3">
          <div class="col-sm-6">
            <label for="usuario" class="form-label">CPF</label>
            <input :disabled="register.usuarioTipo == 'PF_TITULAR'" class="form-control" type="text" id="usuario"
              placeholder="000.000.000-00" v-model="register.cpfTitular"
              v-mask="['###.###.###-##', '##.###.###/####-##']" required />
          </div>
          <div class="col-sm-6">
            <label for="dataNascimento" class="form-label">Data de nascimento</label>
            <input class="form-control" v-model="register.dataNascimento" placeholder="00/00/0000" id="dataNascimento"
              format="DD/MM/YYYY" v-mask="'##/##/####'" required pattern=".{10}" @blur="validarData" />
          </div>
        </div>
        <div class="row mb-3 g-3">
          <div class="col-sm-6">
            <label for="nome" class="form-label">Nome</label>
            <input class="form-control" type="text" id="nome" placeholder="Nome" v-model="register.nome" required />
          </div>
          <div class="col-sm-6">
            <label for="sobrenome" class="form-label">Sobrenome</label>
            <input class="form-control" type="text" id="sobrenome" placeholder="Sobrenome" v-model="register.sobrenome"
              required />
          </div>
        </div>

        <div class="row mb-3 g-3">
          <div class="col-sm-6">
            <label for="celular" class="form-label">Celular</label>
            <input class="form-control" type="tel" id="celular" v-model="register.celular"
              v-mask="['(##) ####-####', '(##) #####-####']" placeholder="(00) 00000-0000" required />
          </div>
          <div class="col-sm-6">
            <label for="email" class="form-label">E-mail</label>
            <input class="form-control" type="text" id="email" placeholder="seu@email.com" v-model="register.email"
              required />
          </div>

        </div>

        <div class="row mb-3 g-3">
          <div class="col-sm-6">
            <label for="enderecoCep" class="form-label">Informe o CEP (Opcional)</label>
            <input @keyup.enter="getByCep(false)" @blur="getByCep(false)" class="form-control" type="text"
              id="enderecoCep" placeholder="00000-00" v-model="register.endereco.cep" v-mask="['#####-###']" />
            <small class="text-muted" v-if="loadingCep">
              <span class="spinner-border spinner-border-sm"></span>
              Buscando seu CEP
              <span class="button-loader grey ml-2"></span>
            </small>
            <small class="text-danger" v-if="cepNaoLocalizado && !isConsultaCepPJ">CEP não localizado</small>
          </div>
          <div class="col-sm-6">
            <label for="enderecoUf" class="form-label">UF (Opcional)</label>
            <input disabled class="form-control" type="text" id="enderecoUf" v-model="register.endereco.estado" />
          </div>
        </div>
        <div class="row mb-3 g-3">
          <div class="col-sm-6">
            <label for="enderecoCidade" class="form-label">Cidade (Opcional)</label>
            <input disabled class="form-control" type="text" id="enderecoCidade" v-model="register.endereco.cidade" />
          </div>
          <div class="col-sm-6">
            <label for="enderecoBairro" class="form-label">Bairro (Opcional) </label>
            <input disabled class="form-control" type="text" id="enderecoBairro" v-model="register.endereco.bairro" />
          </div>
        </div>
        <div class="row mb-3 g-3">
          <div class="col-sm-6">
            <label for="enderecoLogradouro" class="form-label">Endereço (Opcional)</label>
            <input disabled class="form-control" type="text" id="enderecoLogradouro"
              v-model="register.endereco.endereco" />
          </div>
          <div class="col-sm-6">
            <label for="enderecoNumero" class="form-label">Número (Opcional)</label>
            <input class="form-control" type="text" id="enderecoNumero" v-model="register.endereco.numero" />
          </div>
        </div>
        <div class="row mb-3 g-3">
          <div class="col-sm-6">
            <label for="enderecoComplemento" class="form-label">Complemento (Opcional)</label>
            <input class="form-control" type="text" id="enderecoComplemento" v-model="register.endereco.complemento" />
          </div>
        </div>


        <div class="row mb-3 g-3 mt-5">
          <div class="col">
            <h5><strong>Cupom de indicação (Opcional)</strong></h5>
            <div class="a-divider a-divider-break"></div>
          </div>
        </div>
        <div class="row mb-3 g-3">
          <div class="col-sm-6">
            <label for="codigoIndicacao" class="form-label">Código do Cupom</label>
            <input class="form-control" type="text" id="codigoIndicacao" v-model="register.codigoIndicacao" />

          </div>
          <div class="col-sm-6">
          </div>

        </div>
        <small>*Caso você tenha sido indicado por um amigo, informe aqui o código do cupom.</small>
        <div class="row mb-3 g-3 mt-5">
          <div class="col">
            <h5><strong>Termos</strong></h5>
            <div class="a-divider a-divider-break"></div>
          </div>
        </div>
        <p class="mt-2" style="font-size: 0.9rem;">
          Ao efetuar o cadastro, você concorda com os
          <a href="#" @click="lerTermos">
            <span>termos de uso e política de privacidade</span>
          </a>
          da plataforma
        </p>

        <div class="mt-3 mb-5 px-3 col-12 d-flex flex-column flex-lg-row justify-content-between">
          <button class="btn btn_color_system px-5 mt-4 py-2" @click="$router.go(-1)">
            VOLTAR
          </button>
          <button class="btn btn_color_system py-2 px-5 mt-4" type="submit">
            CRIAR CONTA
          </button>
        </div>

      </form>
    </div>
    <Loading v-if="loading"></Loading>
  </main>
</template>

<script>
// @ is an alias to /src
import { APIService } from "../APIService";
const apiService = new APIService();
import { sha256 } from "../shared/helpers/helpers";
import Loading from "@/components/Loading.vue";

export default {
  name: "Cadastrar",
  components: { Loading },
  data() {
    return {
      termos: "termos-de-uso",
      register: {
        nome: "",
        sobrenome: "",
        usuario: "",
        email: "",
        celular: "",
        password: "",
        dataNascimento: "",
        usuarioTipo: "",
        cpfTitular: "",
        cnpj: "",
        razaoSocial: "",
        nomeFantasia: "",
        endereco: {
          cep: "",
          endereco: "",
          complemento: "",
          numero: "",
          bairro: "",
          cidade: "",
          estado: "",
          pais: ""
        }, enderecoPJ: {
          cep: "",
          endereco: "",
          complemento: "",
          numero: "",
          bairro: "",
          cidade: "",
          estado: "",
          pais: ""
        }

      },
      codigo: "",
      loadingCep: false,
      cepNaoLocalizado: false,
      isConsultaCepPJ: false,
      loading: false,
      erro: ""
    };
  },
  mounted() {

    let cpfCnpj = this.removeMask(this.$route.query.cpfCnpj);

    if (this.$store.state.dadosCadastroConta && this.$store.state.dadosCadastroConta.usuario == cpfCnpj) {
      this.register = this.$store.state.dadosCadastroConta;
    } else {
      this.register.usuario = cpfCnpj;
      if (cpfCnpj.length > 11) {
        this.register.usuarioTipo = "PJ_TITULAR"
        this.register.cnpj = cpfCnpj;
      } else {
        this.register.usuarioTipo = "PF_TITULAR"
        this.register.cpfTitular = cpfCnpj;
      }
    }
  },
  methods: {
    validarSenha() {
      return this.validarSenhaTamanho() && this.validarSenhaNumeros() && this.validarSenhaLetras() && this.validarSenhaCaracteresEspeciais();
    },
    validarSenhaNumeros() {
      var numeros = /([0-9])/;
      return this.register.password.match(numeros);
    },
    validarSenhaLetras() {
      var alfabeto = /([a-zA-Z])/;
      return this.register.password.match(alfabeto);
    },
    validarSenhaCaracteresEspeciais() {
      var chEspeciais = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<])/;
      return this.register.password.match(chEspeciais);
    },
    validarSenhaTamanho() {
      return this.register.password.length >= 6;
    },
    lerTermos() {
      this.$store.dispatch("dadosCadastroContaStorage", this.register);
      this.$router.push({
        path: `/pagina/politica-de-privacidade`,
        query: { nextUrl: this.$route.query.nextUrl }
      })
    },
    getByCep(isPJ) {
      this.isConsultaCepPJ = false;
      let cep = isPJ ? this.register.enderecoPJ.cep : this.register.endereco.cep;
      if (isPJ) {
        this.register.enderecoPJ = {};
        this.isConsultaCepPJ = true;
      } else {
        this.register.endereco = {};
      }
      this.cepNaoLocalizado = false;
      if (!this.loadingCep) {
        this.loadingCep = true;
        apiService
          .getCep(cep)
          .then(res => {
            if (res) {
              if (isPJ) {
                this.register.enderecoPJ = res;
              } else {
                this.register.endereco = res;
              }
              this.loadingCep = false;
            }
            else {
              this.loadingCep = false;
              this.cepNaoLocalizado = true;
            }
          })
          .catch(() => {
            this.loadingCep = false;
            this.cepNaoLocalizado = true;
          })
          .finally(() => {
            this.loadingCep = false;
          });
      }
    },
    registerUser() {

      this.$store.dispatch("dadosCadastroContaStorage", this.register);
      this.erro = "";

      if (this.validarSenha()) {
        this.loading = true;
        const dateSplit = this.register.dataNascimento.split("/");
        apiService
          .register({
            nome: `${this.register.nome} ${this.register.sobrenome}`,
            usuario: this.removeMask(this.register.usuario),
            email: this.register.email,
            celular: this.removeMask(this.register.celular),
            hashSenha: sha256(this.register.password),
            dataNascimento: `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`,
            cpfTitular: this.removeMask(this.register.cpfTitular),
            cnpj: this.removeMask(this.register.cnpj),
            razaoSocial: this.register.razaoSocial,
            nomeFantasia: this.register.nomeFantasia,
            codigoIndicacao: this.register.codigoIndicacao,
            usuarioTipo: this.register.usuarioTipo,
            endereco: this.register.endereco,
            enderecoPJ: this.register.enderecoPJ
          })
          .then(() => {
            this.$store.dispatch("loginApp", this.register);
            this.$router.push({
              path: `/validar-codigo`,
              query: { cpfCnpj: this.removeMask(this.register.usuario), nextUrl: this.$route.query.nextUrl }
            })
            this.loading = false;
          })
          .catch(error => {
            this.erro = error.response.data.title;
            this.loading = false;
            window.scrollTo(0, 0);
          });
      } else {
        this.erro = "Senha inválida!";
        window.scrollTo(0, 0);
      }
    },
    validarData() {
      if (!this.$moment(this.register.dataNascimento, "DD/MM/YYYY").isValid())
        this.register.dataNascimento = "";
    },
    removeMask(n) {
      return n.replace(/\D/gm, "");
    }
  }
};
</script>
<style scoped lang="scss">
button {
  background: var(--cor-principal);
  color: var(--cor-texto);
}

.a-divider.a-divider-break {
  text-align: center;
  position: relative;
  top: 2px;
  padding-top: 1px;
  margin-bottom: 14px;
  line-height: 0;

  &:after {
    content: "";
    width: 100%;
    background-color: transparent;
    display: block;
    height: 1px;
    border-top: 1px solid var(--cor-secundaria);
    position: absolute;
    top: 50%;
    margin-top: -1px;
    z-index: 1;
  }

  h5 {
    line-height: 1;
    font-size: 12px;
    color: #767676;
    font-weight: 400;
    z-index: 2;
    position: relative;
    display: inline-block;
    background-color: #fff;
    padding: 0 8px 0 7px;
  }
}
</style>
